import { SelectContentProps } from 'components/ui/Forms';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useProductUnit() {
  const { token } = useAuth();
  const getUnits = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get(`/products/units`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((unit: any) => ({
      value: unit.name,
      name: unit.name,
    }));
  };

  return { getUnits };
}
